import { render } from "./UserConsent.vue?vue&type=template&id=06d5ae26"
import script from "./UserConsent.vue?vue&type=script&lang=js"
export * from "./UserConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__